
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{ discountsInfo.Titulo_Pagina }}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0 tab-style4">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-3 col-xxl-3 pe-lg-0 px-2 mt-5">
          <!-- start tab navigation -->
          <ul class="nav nav-tabs sticky-lg-top">
            <li *ngFor="let desconto of discountsInfo.Descontos; let i = index;" class="nav-item color-black">
              <a
                (click)="scrollToTab(i)"
                [ngClass]="{active: i == activeTab}"
                class="nav-link"
                href="javascript:void(0);">
                {{ desconto.Titulo }}
              </a>
            </li>
          </ul>
          <!-- end tab navigation -->
        </div>
        <div class="col-12 col-lg-9 col-xxl-7 ps-lg-0 px-2">
          <div class="tab-content">
            <p [innerHTML]="discountsInfo.Texto_Pagina"></p>
            <!-- start tab content -->
            <div *ngFor="let desconto of discountsInfo.Descontos; let i = index;" [id]="i" class="discount p-top-tabs-content">
              <div class="row align-items-center">
                <div class="col-12">
                  <h4 class="mb-3">{{ desconto.Titulo }}</h4>
                  <p [innerHTML]="desconto.Conteudo"></p>
                </div>
              </div>
            </div>
            <!-- end tab content -->
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

